import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class ClientTimezoneInterceptor implements HttpInterceptor {
  private readonly CLIENT_TIMEZONE_OFFSET_HEADER_KEY =
    "x-client-timezone-offset";
  private readonly CLIENT_TIMEZONE_HEADER_KEY = "x-client-timezone";

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const now = new Date();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const offset = String(now.getTimezoneOffset());
    const cloned = request.clone({
      headers: request.headers
        .set(this.CLIENT_TIMEZONE_HEADER_KEY, timezone)
        .set(this.CLIENT_TIMEZONE_OFFSET_HEADER_KEY, offset),
    });

    return next.handle(cloned);
  }
}
